<template>
  <div class="lrb_wrapper">
    <div class="lrb_t">
      <nav class="lrb_nav_top flex-center" ref="navTag">
        <div class="lrb_nav_logo">
          <img src="@/assets/image/logo.png" alt="">
        </div>
        <ul class="lrb_t_items flex-center">
          <li v-for="(item,idx) in menuList" :key="idx" class="lrb_tag_item"
              :class="index === item.index ? 'active':''" @click="onChange(item.index)">
            <a class="lrb_link">{{ item.label }}</a>
          </li>
        </ul>
      </nav>
      <div class="lrb_top_content flex-center">
        <!-- <div>发展软件产业</div>
        <div class="lrb_dot"></div>
        <div>创新软件科技</div> -->
      </div>
    </div>

    <div class="lrb_m" id="1" ref="secPage">
      <div class="product_box">
        <img src="@/assets/image/product.png" alt=""/>
        <img src="@/assets/image/soft.png" alt="">
      </div>
    </div>

    <div class="lrb_m about_box" id="2">
      <div class="company_info">
        <div class="title_box">关于我们</div>
        <div class="lrb_info_box">
          <p class="title">深圳火星电源实业有限公司</p>
          <p>
            深圳火星电源实业有限公司(以下简称"火星电源”)成立于2025年，拥有独立自主的设计研发、采购生产及销售服务体系，致力于为用户提供一站式的手机移动充电解决方案。主要业务涵盖:共享充电宝租借、品牌定制、广告展示设备及广告传播等服务。</p>
          <p>
            火星电源拥有业内技术前沿的多产品线，包括各类大中小型机柜及桌面型产品，轻松适用于各类场景。目前全国已有超过80%的城市实现业务服务落地，全方位满足用户需求。</p>
          <p>
            火星电源专注品牌，追求品质，不仅专注于提升产品性能及用户体验，同时还注重保障合作伙伴的权益，为火星电源合伙人提供多方位的保障，实现互利共赢。</p>
        </div>
      </div>
      <div class="img_box">
        <img src="@/assets/image/about.png" alt="">
      </div>
    </div>

    <div class="product_box" id="3">
      <img src="@/assets/image/partner.png" alt="">
    </div>

    <div class="footer_box">
      <div class="img_box">
        <img src="@/assets/image/footer.png" alt="">
      </div>
      <div class="info">
        <div class="logo">
          <img src="@/assets/image/logo.png" alt="">
        </div>
        <div class="cell">
          <span>咨询热线</span>
          <span class="sp">4009-588-699</span>
        </div>
<!--        <div class="cell">-->
<!--          <span>邮箱</span>-->
<!--          <span class="sp">xucanli@szhades.cn</span>-->
<!--        </div>-->
      </div>

      <div class="copy_box">
        <span>邮编: 518000 <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2025400012号</a></span>
        <span>Copyright©2021-2026 深圳火星电源实业有限公司 版权所有</span>
      </div>

    </div>


  </div>
</template>

<script>
import $ from 'jquery'

export default {
  name: 'index',
  data: () => ({
    index: 0,
    menuList: [
      {label: '首页', index: 0},
      {label: '产品介绍', index: 1},
      {label: '关于我们', index: 2},
      {label: '代理加盟', index: 3},
    ]
  }),
  mounted() {
    // window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    //离开该页面需要移除这个监听的事件
    // window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    backTop() {
      this.index = 0
      $('body,html').animate({
        scrollTop: 0,
      })
    },
    onChange(index) {
      this.index = parseInt(index)
      if (index === 0) {
        this.backTop()
        return
      }
      // if (this.index === 1) {
      //   $.scrollTo('#1', 300)
      // } else {
      //   $.scrollTo('#2', 500)
      // }
      $.scrollTo('#' + index, 500)
    },
    handleScroll() {
      //获取滚动条的高度
      let scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop
      let secTp = this.$refs.secPage.offsetTop
      let thrTp = this.$refs.thrPage.offsetTop
      let navTag = this.$refs.navTag.offsetHeight
      if (scrollTop < secTp - navTag) {
        this.index = 0
      } else {
        if (scrollTop > thrTp - navTag) {
          this.index = 2
        } else {
          this.index = 1
        }
      }
    },
    //获取当前元素的offsetTop
    getOffsetTop(obj) {
      let offsetTop = 0
      while (obj != window.document.body && obj != null) {
        offsetTop += obj.offsetTop
        obj = obj.offsetParent
      }
      return offsetTop
    },
  },
}
</script>

<style lang="scss" scoped>
.product_box {
  img {
    width: 100%;
  }
}

.about_box {
  padding: 1.20rem 0 0.78rem 0;
  display: flex;
  width: 12.8rem;
  box-sizing: border-box;
  margin: 0 auto;

  .company_info {
    flex: 1;
    font-style: normal;
    font-family: PingFang SC, PingFang SC;
    color: #000000;

    .title_box {
      font-weight: 600;
      font-size: 0.64rem;
      color: #45464e;
      line-height: 0.90rem;
    }

    p {
      font-weight: 400;
      font-size: 0.24rem;
      color: #000000;
      line-height: 0.50rem;
      font-style: normal;
      text-indent: 2em;
    }

    .title {
      font-weight: 600;
      font-size: 0.40rem;
      line-height: 0.56rem;
      text-indent: 0;
      margin-bottom: 0.26rem;
    }

  }

  .img_box {
    width: 4.28rem;
    margin-left: 1.45rem;
    flex-shrink: 0;
    padding-top: 1.36rem;

    img {
      width: 100%;
    }
  }
}

.footer_box {
  width: 12.8rem;
  padding: 0.25rem 0;
  margin: 0 auto;
  height: 3.11rem;
  box-sizing: border-box;

  img {
    width: 100%;
  }

  .info {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0.49rem 0;
    border-bottom: 1px solid #C5C5C5;

    .logo {
      img {
        width: 1.4rem;
      }
    }

    .cell {
      display: flex;
      flex-direction: column;
      font-size: 0.15rem;
      color: #3D485D;
      margin-left: 1.06rem;

      .sp {
        font-size: 0.17rem;
        margin-top: 0.08rem;
      }
    }
  }

  .copy_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.25rem 0;

    font-weight: 400;
    font-size: 0.16rem;
    color: #3D485D;
    line-height: 0.24rem;

    a {
      color: #3D485D;
    }
  }
}
</style>
